<template>
  <Layout container>
    <div class="w-4/5 md:w-1/2 mx-auto text-center flex flex-col items-center justify-items-center">
      <h1 class="text-4xl my-8">Noël approche !</h1>
      <p class="text-xl mb-6">
        Invitez tous vos proches <br class="lg:hidden" />
        pour déterminer vos <br />Pères Noël secrets <i class="fas fa-gift"></i>
      </p>
      <div v-if="isLoading">
        Chargement en cours...
      </div>
      <div v-else class="flex flex-col w-full md:w-1/2">
        <router-link
          v-for="event in events"
          :key="event.id"
          :to="`/events/${event.id}`"
          class="shadow bg-white hover:bg-gray-50 w-full text-gray-900 py-2 px-4 mb-4 rounded"
        >
          <div class="font-bold text-xl mb-2">{{ event.name }}</div>
          <div>
            <i class="fas fa-users"></i>
            {{ event.participants.length }} participants
          </div>
        </router-link>
        <img src="@/assets/img/empty.svg" class="w-5/6 mx-auto mt-12 mb-24" alt="empty-events" v-show="isEmpty" />
        <Button @click="$router.push('/events/create')" class="mb-24">
          Créer un évenement
        </Button>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex';

import Layout from '@/components/layouts/Layout.vue';
import Button from '@/components/ui/Button.vue';

export default {
  name: 'Home',
  components: {
    Layout,
    Button,
  },
  computed: mapState({
    events: ({ events }) => events.list || [],
    isLoading: ({ events }) => !events.list,
    isEmpty: ({ events }) => (events.list ? events.list.length === 0 : true),
  }),
  async mounted() {
    try {
      await this.$store.dispatch('events/fetch');
    } catch (error) {
      this.$notify.error(error.message);
    }
  },
};
</script>
